<template>
  <Dialog
    title="Order Journey,"
    @close-event="handleClose"
    show-close-button
    show-footer
    custom-footer
    custom-title
    md
  >
    <!-- Custom Title Slot -->
    <template #title>
      <div class="flex items-center gap-2 w-full">
        <h4 class="text-lg text-black">Shipped Order Journey</h4>
      </div>
    </template>
    <!-- Header Right Slot: Actions -->
    <template #header-right> </template>
    <template #modal-content>
      <div>
      <!-- <pre>{{ tracking_response }}</pre> -->
        <DataTable
          :data="tracking_response.history"
          :columns="logo_history_headers"
          :showPagination="false"
        >
        </DataTable>
      </div>
    </template>

    <!-- FOOTER -->
    <template #footer>
      <div class="flex justify-end gap-2 items-center">
        <button class="btn text-sm" @click="handleClose">
          Cancel
        </button>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import DataTable from "@/components/Shared/DataTable.vue";
import Dialog from "@/components/Shared/Dialog.vue";
import { formatDate } from "@/composables";
import { TrackingResponse } from "@/models/TrackingResponse";

const props = withDefaults(defineProps<{
  tracking_response: TrackingResponse;
}>(), {
  tracking_response: null,
});
interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  sortKey?: string;
  renderer?: (value: any, row: any) => string | number;
}

let logo_history_headers: Column[] = [
  { key: "derived_status", label: "Status" },
  { key: "date", label: "Date", renderer: (_: any, row: any) => formatDate(row.date) },
  { key: "country_name", label: "Location (City / Country)", renderer: (_: any, row: any) => `${row.city || 'N/A'} / ${row.country_name || 'N/A'}` },
  { key: "event_description", label: "Description / Sub-status", sortable: false, renderer: (_: any, row: any) => row.event_description || 'N/A' },
];

const emits = defineEmits(["close"]);

const handleClose = () => emits("close");
</script>

<style scoped lang="scss">
.btn {
  @apply px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-md flex items-center gap-2 disabled:cursor-not-allowed disabled:opacity-50;
}

.badge {
  @apply px-3 py-2 rounded-md flex items-center gap-2 text-sm;
}
.badge-warning {
  background: #f9b115;
  color: #4f5d73;
}
.badge-success {
  background: #2eb85c;
  color: white;
}
.badge-danger {
  background: #e55353;
  color: white;
}
</style>